import { cspmEngine } from './cspm';
import { guarddutyEngine } from './guardduty';
import { macieEngine } from './macie';
import { inspectorEngine } from './inspector';
import { detectiveEngine } from './detective';
import { accessAnalyzerEngine } from './accessanalyzer';

// Ordered list of engines — registration order IS the UI order, and must match
// NewEngineRegistry in backend/main.go so the sidebar, Overview tiles and the
// capabilities panel all present engines in one consistent order.
export const ENGINES = [cspmEngine, guarddutyEngine, macieEngine, inspectorEngine, detectiveEngine, accessAnalyzerEngine];
export const engineById = (id) => ENGINES.find((e) => e.id === id);
